
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { LayoutWithHeaderAndFooter } from '@/common/components/layouts/layoutWithHeaderAndFooter';
import Seo from '@/common/components/layouts/seo';
import { withServerUtils } from '@/common/hoc/withServerUtils';
import AppDownload from '@/modules/appDownload/views/appDownload';
import { GetServerSideProps, GetServerSidePropsContext } from 'next';
import { ReactElement } from 'react';

const CANONICAL_URL = 'https://www.paziresh24.com/app/';

const AppDownloadPage = () => (
  <>
    <Seo
      title="دانلود اپلیکیشن نوبت دهی پزشکان پذیرش24"
      description="با نرم افزار نوبت دهی پزشکان پذیرش24، در سریعترین زمان نوبت دلخواه خود را دریافت کرده و از خدمات بهترین اپلیکیشن سلامت کشور بهره‌مند شوید."
      canonicalUrl={CANONICAL_URL}
    />
    <AppDownload />
  </>
);

AppDownloadPage.getLayout = function getLayout(page: ReactElement) {
  return (
    <LayoutWithHeaderAndFooter {...page.props.config} shouldShowPromoteApp={false} showBottomNavigation={false} className="bg-[#F2F3F5]">
      {page}
    </LayoutWithHeaderAndFooter>
  );
};

 const _getServerSideProps: GetServerSideProps = withServerUtils(async (context: GetServerSidePropsContext) => ({
  props: { query: context.query },
}));

export default AppDownloadPage;


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/app/index',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  